import React from 'react';
import ReactDOM from 'react-dom';
import Listings from './Container';
import ProfileSideBar from '../Common/ProfileSideBar/ProfileSideBar';
import { MessageProvider } from '../Common/Message';
import { PagingProvider } from '../Common/Paging/PagingContext';

ReactDOM.render(
    <React.StrictMode>
        <MessageProvider>
            <PagingProvider>
                <Listings />
            </PagingProvider>
        </MessageProvider>
    </React.StrictMode>,
    document.querySelector('#UserListingsComponent')
);

ReactDOM.render(
    <React.StrictMode>
        <MessageProvider>
            <ProfileSideBar />
        </MessageProvider>
    </React.StrictMode>,
    document.querySelector('#ProfileSideBar')
);
